import script from "./AnnualStatement.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnualStatement.vue?vue&type=script&setup=true&lang=ts"

import "./AnnualStatement.vue?vue&type=style&index=0&id=6cfd36d6&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfd36d6"]])

export default __exports__